import { render } from "./ProcessTrends.vue?vue&type=template&id=a425a21e"
import script from "./ProcessTrends.vue?vue&type=script&lang=js"
export * from "./ProcessTrends.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__